import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Benefits() {
  const benefitsList = ['Entender cómo funciona el marketing digital sin complicarte.', 'Crear campañas con estructura y no por intuición.', 'Usar IA para ahorrar tiempo y tomar mejores decisiones.', 'Aprender con cursos prácticos y organizados.', 'Recibir acompañamiento dentro de una comunidad en Skool.', 'Construir tu primera estrategia digital con ayuda de Alice.'];
  return <section className="py-12 lg:py-16 bg-link-navy text-white relative overflow-hidden" data-id="element-43">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-link-blue/20 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/3" data-id="element-44" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-cyan-500/10 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/3" data-id="element-45" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-46">
        <div className="max-w-4xl mx-auto" data-id="element-47">
          <div className="text-center mb-10" data-id="element-48">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-49">
              Lo que vas a conseguir dentro de Link Academy
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-50">
            {benefitsList.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -20 : 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-white/5 p-6 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-51">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-link-blue flex items-center justify-center mt-1" data-id="element-52">
                  <Check size={18} className="text-white" data-id="element-53" />
                </div>
                <p className="text-lg text-blue-50 leading-relaxed font-medium" data-id="element-54">
                  {benefit}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}